import { useNavigate } from 'react-router-dom';

import getEnvConfig from '../../../../../utils/config/env';
import { SHOP_CURRENT_ROUTE } from '../../../utils/constants';

export const useSetting = () => {
    const navigate = useNavigate();

    const viewSetting = (link: string) => {
        if (!link) return;
        navigate(`${getEnvConfig().PUBLIC_PATH}/${SHOP_CURRENT_ROUTE}/${link}`);
    };

    return { viewSetting };
};
